export default __webpack_public_path__ + "static/media/Festrahmentür B.d732f98f.jpg";